var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconUser(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.1636 25.2229C20.1369 25.5262 18.9236 25.6662 17.5002 25.6662H10.5002C9.07691 25.6662 7.86358 25.5262 6.83691 25.2229C7.09358 22.1895 10.2086 19.7979 14.0002 19.7979C17.7919 19.7979 20.9069 22.1895 21.1636 25.2229Z",
    stroke: "#040E26",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.4997 2.3335H10.4997C4.66634 2.3335 2.33301 4.66683 2.33301 10.5002V17.5002C2.33301 21.9102 3.66301 24.3252 6.83634 25.2235C7.09301 22.1902 10.208 19.7985 13.9997 19.7985C17.7913 19.7985 20.9063 22.1902 21.163 25.2235C24.3363 24.3252 25.6663 21.9102 25.6663 17.5002V10.5002C25.6663 4.66683 23.333 2.3335 17.4997 2.3335ZM13.9997 16.5318C11.6897 16.5318 9.82301 14.6535 9.82301 12.3435C9.82301 10.0335 11.6897 8.16683 13.9997 8.16683C16.3097 8.16683 18.1763 10.0335 18.1763 12.3435C18.1763 14.6535 16.3097 16.5318 13.9997 16.5318Z",
    stroke: "#040E26",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18.1766 12.3432C18.1766 14.6532 16.3099 16.5315 13.9999 16.5315C11.6899 16.5315 9.82324 14.6532 9.82324 12.3432C9.82324 10.0332 11.6899 8.1665 13.9999 8.1665C16.3099 8.1665 18.1766 10.0332 18.1766 12.3432Z",
    stroke: "#040E26",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconUser);
export default __webpack_public_path__ + "static/media/iconUser.090b65fd17457627772e64bbbd780c31.svg";
export { ForwardRef as ReactComponent };